import { render, staticRenderFns } from "./fawuqingfeng.vue?vue&type=template&id=3e83e2e9&scoped=true"
import script from "./fawuqingfeng.vue?vue&type=script&lang=js"
export * from "./fawuqingfeng.vue?vue&type=script&lang=js"
import style0 from "./fawuqingfeng.vue?vue&type=style&index=0&id=3e83e2e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e83e2e9",
  null
  
)

export default component.exports